var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5392 2.16663H8.46085C4.51752 2.16663 2.16669 4.51746 2.16669 8.46079V17.5283C2.16669 21.4825 4.51752 23.8333 8.46085 23.8333H17.5284C21.4717 23.8333 23.8225 21.4825 23.8225 17.5391V8.46079C23.8334 4.51746 21.4825 2.16663 17.5392 2.16663ZM17.7342 15.5458L15.3292 17.9508C14.7442 18.5358 13.9859 18.8175 13.2275 18.8175C12.4692 18.8175 11.7 18.525 11.1259 17.9508C10.5625 17.3875 10.2484 16.64 10.2484 15.8491C10.2484 15.0583 10.5625 14.3 11.1259 13.7475L12.6534 12.22C12.9675 11.9058 13.4875 11.9058 13.8017 12.22C14.1159 12.5341 14.1159 13.0541 13.8017 13.3683L12.2742 14.8958C12.0142 15.1558 11.8734 15.4916 11.8734 15.8491C11.8734 16.2066 12.0142 16.5533 12.2742 16.8025C12.805 17.3333 13.6609 17.3333 14.1917 16.8025L16.5967 14.3975C17.9725 13.0216 17.9725 10.79 16.5967 9.41413C15.2209 8.03829 12.9892 8.03829 11.6134 9.41413L8.99169 12.0358C8.43919 12.5883 8.13585 13.3141 8.13585 14.0833C8.13585 14.8525 8.43919 15.5891 8.99169 16.1308C9.30585 16.445 9.30585 16.965 8.99169 17.2791C8.67752 17.5933 8.15752 17.5933 7.84335 17.2791C6.97669 16.445 6.50002 15.3075 6.50002 14.0941C6.50002 12.8808 6.96585 11.7433 7.82169 10.8875L10.4434 8.26579C12.4475 6.26163 15.7192 6.26163 17.7234 8.26579C19.7384 10.27 19.7384 13.5416 17.7342 15.5458Z",
    fill: "url(#paint0_linear_330_10376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_10376",
    x1: 2.16669,
    y1: 13,
    x2: 23.8226,
    y2: 13.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38EF7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon3);
export default __webpack_public_path__ + "static/media/features-icon-3.8bea8f5ea43635432912911ba3bd37ca.svg";
export { ForwardRef as ReactComponent };